module.exports = __webpack_public_path__ + "static/media/logo-horiz-white.4b4f3fa9.png";